<template>

    <project-tasks
        :tasks-uri="route('api.v1.tasks.show', {'project_uuid': project.uuid})"
        :new-task-post-uri="route('api.v1.tasks.add', {project_uuid: project.uuid})"
        :project-uuid="project.uuid"
        :task-uuid="task_uuid"
        :show-buttons="getProject.access.tasks.write"
        :show-budget="getProject.access.finance"
    ></project-tasks>

</template>

<script>

import { mapGetters } from 'vuex';
import Lang from '../../../Lang';
import ProjectTasks from "../../../components/Tasks/ProjectTasks";

export default {

    components: {
        ProjectTasks,
    },

    computed: {
        ...mapGetters([
            'getProject',
        ]),

        project() {
            return this.getProject;
        },
    },

    data() {
        return {
            Lang:Lang,
            task_uuid:null,
        }
    },

    metaInfo: {
        title:'Project taken',
    },

    mounted() {
        if (this.$route.params.task_uuid) {
            this.task_uuid = this.$route.params.task_uuid;
        }
    },

    name:'ProjectsDetailsTasks',

}

</script>
